// extracted by mini-css-extract-plugin
export var contentBody = "_5o-9";
export var headerImage = "_5o-2";
export var imageButton = "_5o-7";
export var imageButtonIcon = "_5o-8";
export var imageHeader = "_5o-4";
export var imageHeaderText = "_5o-5";
export var imageOverlay = "_5o-3";
export var imageTitle = "_5o-6";
export var imageWrapper = "_5o-1";
export var taskList = "_5o-a";
export var widget = "_5o-0";